// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes zoomIn {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.98);
  }
  100% {
    transform: scale(1);
  }
}
.primary {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 66px !important;
  font-size: x-large;
  box-shadow: 0 0 6px 2px rgb(141, 198, 63);
  border: none;
  /* Smooth the scaling effect. */
  transition: transform 0.3s ease-in-out;
}
.primary label:hover {
  cursor: pointer;
}
.primary:hover {
  cursor: pointer;
  background: #ffffff;
  box-shadow: 0 0 10px 4px rgb(141, 198, 63);
  transform: scale(1.1);
  /* Specify the animation for this element. */
  animation: zoomIn 2s infinite;
}
.primary:active {
  background-color: rgba(141, 198, 63, 0.4);
}

.secondary {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 66px !important;
  font-size: x-large;
  box-shadow: 0 0 6px 2px #1d0f40;
  border: none;
  /* Smooth the scaling effect. */
  transition: transform 0.3s ease-in-out;
}
.secondary label:hover {
  cursor: pointer;
}
.secondary:hover {
  cursor: pointer;
  background: #ffffff;
  box-shadow: 0 0 10px 4px rgb(29, 15, 64);
  transform: scale(1.1);
  /* Specify the animation for this element. */
  animation: zoomIn 2s infinite;
}
.secondary:hover:active {
  background-color: rgba(141, 198, 63, 0.4);
}

.primary.selected {
  box-shadow: 0 0 10px 4px rgb(141, 198, 63);
  background: rgba(141, 198, 63, 0.25);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  /* Smooth the scaling effect. */
  transition: transform 0.3s ease-in-out;
}
.primary.selected label:hover {
  cursor: pointer;
}
.primary.selected:hover {
  transform: scale(1.1);
  /* Specify the animation for this element. */
  animation: zoomIn 2s infinite;
  background-color: rgba(141, 198, 63, 0.1);
}

.secondary.selected {
  box-shadow: 0 0 10px 4px rgb(141, 198, 63);
  background: rgba(141, 198, 63, 0.25);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  /* Smooth the scaling effect. */
  transition: transform 0.3s ease-in-out;
}
.secondary.selected label:hover {
  cursor: pointer;
}
.secondary.selected:hover {
  background-color: rgba(141, 198, 63, 0.1);
  transform: scale(1.1);
  /* Specify the animation for this element. */
  animation: zoomIn 2s infinite;
}

.print-btn {
  position: relative;
  right: -30%;
}`, "",{"version":3,"sources":["webpack://./src/components/select-row/select-row.styles.scss"],"names":[],"mappings":"AAAA;EACE;IACE,mBAAA;EACF;EACA;IACE,sBAAA;EACF;EACA;IACE,mBAAA;EACF;AACF;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yCAAA;EACA,YAAA;EACA,+BAAA;EACA,sCAAA;AAAF;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,qBAAA;EACA,4CAAA;EACA,6BAAA;AADJ;AAGE;EACE,yCAAA;AADJ;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;EACA,YAAA;EACA,+BAAA;EACA,sCAAA;AAFF;AAIE;EACE,eAAA;AAFJ;AAKE;EACE,eAAA;EACA,mBAAA;EACA,wCAAA;EACA,qBAAA;EACA,4CAAA;EACA,6BAAA;AAHJ;AAII;EACE,yCAAA;AAFN;;AAOA;EACE,0CAAA;EACA,oCAAA;EACA,0BAAA;EACA,kCAAA;EAEA,+BAAA;EACA,sCAAA;AALF;AAOE;EACE,eAAA;AALJ;AAQE;EACE,qBAAA;EACA,4CAAA;EACA,6BAAA;EACA,yCAAA;AANJ;;AAUA;EACE,0CAAA;EACA,oCAAA;EACA,0BAAA;EACA,kCAAA;EAEA,+BAAA;EACA,sCAAA;AARF;AAUE;EACE,eAAA;AARJ;AAWE;EACE,yCAAA;EACA,qBAAA;EACA,4CAAA;EACA,6BAAA;AATJ;;AAaA;EACE,kBAAA;EACA,WAAA;AAVF","sourcesContent":["@keyframes zoomIn {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(0.98);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.primary {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 66px !important;\n  font-size: x-large;\n  box-shadow: 0 0 6px 2px rgb(141, 198, 63);\n  border: none;\n  /* Smooth the scaling effect. */\n  transition: transform 0.3s ease-in-out;\n\n  label:hover {\n    cursor: pointer;\n  }\n\n  &:hover {\n    cursor: pointer;\n    background: #ffffff;\n    box-shadow: 0 0 10px 4px rgb(141, 198, 63);\n    transform: scale(1.1);\n    /* Specify the animation for this element. */\n    animation: zoomIn 2s infinite;\n  }\n  &:active {\n    background-color: rgba(141, 198, 63, 0.4);\n  }\n}\n\n.secondary {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 66px !important;\n  font-size: x-large;\n  box-shadow: 0 0 6px 2px #1d0f40;\n  border: none;\n  /* Smooth the scaling effect. */\n  transition: transform 0.3s ease-in-out;\n\n  label:hover {\n    cursor: pointer;\n  }\n\n  &:hover {\n    cursor: pointer;\n    background: #ffffff;\n    box-shadow: 0 0 10px 4px rgb(29, 15, 64);\n    transform: scale(1.1);\n    /* Specify the animation for this element. */\n    animation: zoomIn 2s infinite;\n    &:active {\n      background-color: rgba(141, 198, 63, 0.4);\n    }\n  }\n}\n\n.primary.selected {\n  box-shadow: 0 0 10px 4px rgb(141, 198, 63);\n  background: rgba(141, 198, 63, 0.25);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n\n  /* Smooth the scaling effect. */\n  transition: transform 0.3s ease-in-out;\n\n  label:hover {\n    cursor: pointer;\n  }\n\n  &:hover {\n    transform: scale(1.1);\n    /* Specify the animation for this element. */\n    animation: zoomIn 2s infinite;\n    background-color: rgba(141, 198, 63, 0.1);\n  }\n}\n\n.secondary.selected {\n  box-shadow: 0 0 10px 4px rgb(141, 198, 63);\n  background: rgba(141, 198, 63, 0.25);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n\n  /* Smooth the scaling effect. */\n  transition: transform 0.3s ease-in-out;\n\n  label:hover {\n    cursor: pointer;\n  }\n\n  &:hover {\n    background-color: rgba(141, 198, 63, 0.1);\n    transform: scale(1.1);\n    /* Specify the animation for this element. */\n    animation: zoomIn 2s infinite;\n  }\n}\n\n.print-btn {\n  position: relative;\n  right: -30%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
